import React, { Fragment, useState, useContext, useEffect } from "react";
import "./App.css";
//estilos de material design
//npm install @material-ui/core
//npm install @material-ui/icons
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./theme/theme";
import { Grid, Snackbar } from "@material-ui/core";
//npm i --save react-router-dom
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import EstateList from "./components/views/EstateList";
import Navbar from "./components/layout/AppNavbar";
import RegisterUser from "./components/security/Register";
import Login from "./components/security/Login";
//accedemos a el context del objeto firebase en este componente
import { FirebaseContext } from "./server";
//accede a ambos reducers definidos en carpeta session/reducers
import { useStateValue } from "./session/store";
//permite identificar si la autenticacion esta verificada o no
import AuthPath from "./components/security/AuthPath";
//componente del perfil de usuario
import UserProfile from "./components/security/UserProfile";
//componente de nuevo inmueble
import NewEstate from "./components/views/NewEstate";
//componente para editar inmueble
import EditEstate from "./components/views/EditEstate";
//componente de login por telefono 
import PhoneLogin from "./components/security/PhoneLogin";

function App(props) {
  //extraemos el objeto de firebase en el context de la aplicación
  let firebase = useContext(FirebaseContext);

  //creamos variable y metodo que van a controlar el proceso de llamar al objeto firebase, para ello le damos un estado inicial en false, para que la funcion cambie este valor cuando este preparado el servicio, a través el useEffect y la funcion isInitialize() que devolvera un valor que cambiara el estado de la funcion setupInitFirebase()
  const [init_auth, setupInitFirebase] = useState(false);

  //utilizamos el useReducerValues y extraemos lo valores definidos en el MIDDELWARE session/reducers/index.js -- el dispacth llama al reducer directamente
  //también incluye el valor de session
  const [{ openSnackbar }, dispatch] = useStateValue();

  //llama al objeto firebase y controla si ha sido iniciado
  useEffect(() => {
    firebase.isInitialize().then(resp => {
      setupInitFirebase(resp);
    });
  });

  //solo si el servicio firebase esta iniciado se muestra la informacion indicada
  return init_auth !== false ? (
    <Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={openSnackbar ? openSnackbar.open : false}
        autoHideDuration={3000}
        ContentProps={{
          "aria-describeby": "message-id"
        }}
        message={
          <span id="message-id">
            {openSnackbar ? openSnackbar.message : ""}
          </span>
        }
        onClose={() =>
          //Llamamos al reducer openMessageReducer directamente, lo llamamos a través de useReducerValues que trae los valores de showMessage y el dispatch
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: false,
              message: ""
            }
          })
        }
      ></Snackbar>

      <Router>
        <MuiThemeProvider theme={theme}>
          <Navbar />

          <Grid container>
            <Switch>
              {/* rutas con autenticacion */}
              <AuthPath
                path="/"
                signinFirebase={firebase.auth.currentUser}
                exact
                component={EstateList}
              />
              <AuthPath
                path="/auth/profile"
                signinFirebase={firebase.auth.currentUser}
                exact
                component={UserProfile}
              />
              <AuthPath
                path="/estate/new"
                signinFirebase={firebase.auth.currentUser}
                exact
                component={NewEstate}
              />
              <AuthPath
                path="/estate/:id"
                signinFirebase={firebase.auth.currentUser}
                exact
                component={EditEstate}
              />
              {/* rutas publicas */}
              <Route path="/auth/registro" exact component={RegisterUser} />
              <Route path="/auth/login" exact component={Login} />
              <Route path="/auth/loginPhone" exact component={PhoneLogin} />
            </Switch>
          </Grid>
        </MuiThemeProvider>
      </Router>
    </Fragment>
  ) : null;
}

export default App;
